"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogDestination = void 0;
class ConsoleLogDestination {
    log(entry) {
        const { level, message, timestamp, context } = entry;
        const formatted = `[${timestamp.toLocaleString(undefined, {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        })}] [${level}] ${message}`;
        switch (level) {
            case 'debug':
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                context !== undefined ? console.debug(formatted, context) : console.debug(formatted);
                break;
            case 'info':
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                context !== undefined ? console.info(formatted, context) : console.info(formatted);
                break;
            case 'warn':
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                context !== undefined ? console.warn(formatted, context) : console.warn(formatted);
                break;
            case 'error':
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                context !== undefined ? console.error(formatted, context) : console.error(formatted);
                break;
            default:
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                context !== undefined ? console.log(formatted, context) : console.log(formatted);
        }
    }
}
exports.ConsoleLogDestination = ConsoleLogDestination;
